<template>
  <div class="widget-homepage">
    <component ref="widgetHomepage"
      :is="comTypeList[comType]"
      class="widget-homepage-item"
      :widgetId="widgetId"
      :comSubType="comSubType"
      :isConfig="isConfig"
      :refreshPeriod="refreshPeriod"
      :url="url"
      :stripe="stripe">
    </component>
    <div class="widget-homepage-mask"
      v-if="preview"></div>
  </div>
</template>
<script>
/*
   * 小部件集合组件
   *  1.列表组件
   * comType: simpleTable 组件类型
   * stripe: true/false 是否显示斑马纹，默认不显示
   * widgetId: 存储列表数据的请求id
   * 2.轮播组件
   * comType: picCarousel
   * widgetId: 存储图片数据的请求id
   * 对外提供resizeImage方法（自适应计算图片居中）
   * 3.菜单导航
   * comType: lisLnav
   * subComType: full,card2种类型的导航菜单（全部展示和卡片类型）
   * 4.图表
   * comType: simpleEcharts
   * subComType: echartsLine, echartsBar, echartsPie表示线、柱、饼图
   * widgetId: 图表数据的请求id
   * 对外提供 chartsResize（刷新图表）
   * 5.页面嵌入
   * comType: iframePage
   * url: 嵌入页面的地址
   * 6.待办部件
   * comType:todo
   *
   * */
import picCarousel from './sub-components/pic-carousel'
import simpleTable from './sub-components/simple-table'
import navigation from './sub-components/navigation'
import simpleEcharts from './sub-components/simple-echarts'
import iframePage from './sub-components/iframe-page'
import todo from './sub-components/todo'
export default {
  name: 'widget-homepage',
  props: {
    comType: {
      type: String,
      default: ''
    }, // 组件类型
    widgetId: {
      type: String,
      default: ''
    }, // 组件数据请求id
    comSubType: {
      type: String,
      default: ''
    }, // 组件子类型（折线，饼图和柱状图）
    stripe: {
      type: Boolean,
      default: false
    }, // 列表是否显示斑马纹
    url: {
      type: String,
      default: ''
    },
    preview: {
      // 预览模式，如果是预览模式，在组件上方叠加一个透明的蒙板，防止操作
      type: Boolean,
      default: false
    },
    refreshPeriod: {
      // 部件刷新周期
      type: Number,
      default: 0
    },
    isConfig: {
      type: Boolean,
      default: false
    }

  },
  data () {
    return {
      comTypeList: {
        chart: 'simpleEcharts',
        navigation: 'navigation',
        image: 'picCarousel',
        table: 'simpleTable',
        page: 'iframePage',
        todo: 'todo'
      }
    }
  },
  methods: {
    chartsResize () {
      if (this.$refs.widgetHomepage.resizeChart) {
        this.$refs.widgetHomepage.resizeChart()
      }
    },
    imageResize () {
      if (this.$refs.widgetHomepage.resizeImage) {
        this.$refs.widgetHomepage.resizeImage()
      }
    },
    initCardNav () {
      if (this.$refs.widgetHomepage.initCardStyle) {
        this.$refs.widgetHomepage.initCardStyle()
      }
    }
  },
  components: {
    navigation,
    picCarousel,
    simpleTable,
    simpleEcharts,
    iframePage,
    todo
  }
}
</script>

<style scoped lang="less" rel="stylesheet/less">
@import "~assets/styles/var.less";
@import "~assets/styles/mixin.less";

.widget-homepage {
  width: 100%;
  height: 100%;
  position: relative;
  .widget-homepage-item {
    width: 100%;
    height: 100%;
  }
  .widget-homepage-mask {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 99;
    background-color: transparent;
  }
}
</style>
